package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class SponsorCreateRequest(
    val name: String,
    val description: String? = null,
    val logoUrl: String? = null,
    val websiteUrl: String? = null,
    val contactEmail: String? = null,
    val active: Boolean = true
)

@Serializable
data class SponsorDTO(
    val id: String,
    val name: String,
    val description: String? = null,
    val logoUrl: String? = null,
    val websiteUrl: String? = null,
    val contactEmail: String? = null,
    val active: Boolean
)

@Serializable
data class RewardCreateRequest(
    val title: String,
    val description: String,
    val imageUrl: String? = null,
    val pointsCost: Int,
    val stock: Int,
    val validFrom: String? = null,
    val validUntil: String? = null,
    val terms: String? = null,
    val redemptionType: String = "QR_CODE",
    val active: Boolean = true
)

@Serializable
data class RewardDTO(
    val id: String,
    val sponsorId: String,
    val sponsorName: String,
    val title: String,
    val description: String,
    val imageUrl: String? = null,
    val pointsCost: Int,
    val stock: Int,
    val redeemedCount: Int,
    val availableStock: Int,
    val validFrom: String? = null,
    val validUntil: String? = null,
    val terms: String? = null,
    val redemptionType: String,
    val active: Boolean,
    val affordable: Boolean = false
)

@Serializable
data class RewardRedemptionDTO(
    val id: String,
    val rewardId: String,
    val rewardTitle: String,
    val sponsorName: String,
    val userId: String,
    val pointsCost: Int,
    val code: String,
    val status: String,
    val issuedAt: String,
    val expiresAt: String? = null,
    val redeemedAt: String? = null
)

@Serializable
data class RewardCatalogDTO(
    val pointsBalance: Int,
    val rewards: List<RewardDTO>,
    val redemptions: List<RewardRedemptionDTO>
)

@Serializable
data class RedeemRewardResultDTO(
    val pointsBalance: Int,
    val redemption: RewardRedemptionDTO
)
